module.exports = [{"name":"tait-58-extend-next-page-query","version":2},{"name":"GUARD_GUARD2366","version":1},{"name":"GUARD_GUARD2085","version":1}]